module.exports = __webpack_public_path__ + "img/trial4-3.cf7e84b8.png";